import { TypographyProps } from '@mui/material';
import { TitleSmallBoldStyled, TitleSmallStyled } from './styles';

export const TitleSmall: React.FC<TypographyProps> = (props) => {
  return (
    <TitleSmallStyled variant="caption" {...props}>
      {props.children}
    </TitleSmallStyled>
  );
};

export const TitleSmallBold: React.FC<TypographyProps> = (props) => {
  return (
    <TitleSmallBoldStyled variant="caption" {...props}>
      {props.children}
    </TitleSmallBoldStyled>
  );
};
